var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Radio/RadioGroup.js",
  _this = this;
import React from 'react';
import RadioInput from './RadioInput';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import HintText from '../../core/components/Forms/HintText';
var RadioGroup = function RadioGroup(_ref) {
  var options = _ref.options,
    value = _ref.value,
    name = _ref.name,
    onChange = _ref.onChange,
    error = _ref.error;
  var handleChange = function handleChange(e, radioItem, index) {
    onChange && onChange(e, radioItem, index);
  };
  return /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, options.map(function (radioOption, index) {
    return /*#__PURE__*/React.createElement(RadioInput, {
      key: index,
      onChange: function onChange(e) {
        return handleChange(e, radioOption, index);
      },
      value: radioOption.value,
      checked: radioOption.value === value,
      error: radioOption.error,
      name: name,
      id: radioOption.id,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 16,
        columnNumber: 11
      }
    }, radioOption.label);
  }), error && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    error: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 11
    }
  }, error)));
};
export default RadioGroup;